module.exports = __webpack_public_path__ + "static/media/prismas-background.ed9bdc21.svg";